import React from "react";
import {SosDonationCardType} from "../../types";
import C072FooterColumnLayout from "./C072FooterColumnLayout";
import CCOContainer from "../../fundamentals/CCOContainer";
import {hideForBreakpoint, useBreakpoints} from "../../../utility/layoutUtils";
import dynamic from "next/dynamic";
import CAEGlobalSettings from "../../../types/CAEGlobalSettings";


export interface Props {
    items: Array<any>,
    CAEGlobalSettings: CAEGlobalSettings,
    page?: any,
    isHideNavi?: boolean
}

const CCODonationInitializer = dynamic(() => import('../../fundamentals/CCODonationInitializer'), {ssr: false});

// Footer enthält ein ähnlichen Komponenten Switch wie PlacementItem.
// Sollte Footer ähnlich anwachsen, sollte eine dedizierte ComponentSwitch als eigene Komponente erstellt werden.
function Footer(props: Props) {
    const currentBreakpoint = useBreakpoints();

    const hasStickyDonationCard = props.items.some(
        (i) => i.type === "SOSDonationCard" && !hideForBreakpoint(currentBreakpoint, i.responsiveSettings));

    return <>
        {
            props.items.map((i) => {
                if (hideForBreakpoint(currentBreakpoint, i.responsiveSettings)) {
                    return null
                }
                if (i.type === "SOSDonationCard") {
                    const card = i as SosDonationCardType;
                    if (i.viewtype === "c084_modular_donation_card_sticky") {
                        return (
                            <CCODonationInitializer key={card.id} item={card} donationInitializerData={null}/>
                        );
                    }
                }
            })
        }
        <CCOContainer component="footer"
                      dataCypress='footer'
                      id={"footer"}
                      width={"full"}
                      background={"grey"}
                      border={true}
                      marginTop={hasStickyDonationCard ? 0 : 12}
                      withMobilePadding>
            <>
                {props.items.map((i, index) => {
                    switch (i.type) {
                        case "CMCollection": {
                            switch (i.viewtype) {
                                case "c072_footer4columns": {
                                    return <C072FooterColumnLayout key={index} columns={4} items={i.items}
                                                                   CAEGlobalSettings={props.CAEGlobalSettings}
                                                                   pageProps={props.page}
                                    />
                                }
                                case "c072_footer3columns": {
                                    return <C072FooterColumnLayout key={index} columns={3} items={i.items}
                                                                   CAEGlobalSettings={props.CAEGlobalSettings}
                                                                   pageProps={props.page}
                                    />
                                }
                                default: {
                                    return <React.Fragment key={index}></React.Fragment>
                                }
                            }
                        }
                    }
                })
                }
            </>
        </CCOContainer>
    </>
}

export default Footer
